import { get as lodashGet } from "lodash-es";
import { getIntlBody } from "../../js/_helpers/intl-helpers";
import { getCurrentConfig } from "@certa/queries/hooks/config.hook";

/**
 * Returns the selector that retrives the kind definition of the specified
 * kind tag
 * @param {string} kindTag
 */

export const regionPlaceholderSelector = state => {
  const config = getCurrentConfig();
  const custom_ui_labels = lodashGet(config, "custom_ui_labels", null);
  return custom_ui_labels
    ? getIntlBody(custom_ui_labels, "filterPlaceholders.Region")
    : null;
};
export const businessUnitPlaceholderSelector = state => {
  const config = getCurrentConfig();
  const custom_ui_labels = lodashGet(config, "custom_ui_labels", null);
  return custom_ui_labels
    ? getIntlBody(custom_ui_labels, "filterPlaceholders.Business")
    : null;
};
